import React from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';

import { Container } from './styles';

const Tools = () => {
  return (
    <Container>
      <h3>Tools</h3>
      <ScrollContainer className="scrollContainer">
        <img src="assets/figma.png" title="Figma" alt="figma app" />
        <img src="assets/jira.png" title="Jira" alt="Jira app" />
        <img src="assets/lovable-logo.png" title="Lovable" alt="lovable app" />
        <img src="assets/bolt.jpg" title="Bolt" alt="Bolt app" />
        <img src="assets/invision.png" title="Invision" alt="invision app" />
        <img src="assets/axure.png" title="Axure" alt="axure app" />
        <img src="assets/use-berry.png" title="Use Berry" alt="use-berry app" />
        <img src="assets/analytics.png" title="Analytics" alt="analytics app" />
        <img src="assets/illustrator.png" title="Illustrator" alt="illustrator app" />
        <img src="assets/photoshop.png" title="Photoshop" alt="photoshop app" />
        <img src="assets/visual-eyes.png" title="Visual" alt="visual-eyes app" />
        <img src="assets/notion.png" title="Notion" alt="notion app" />
        <img src="assets/miro.png" title="Miro" alt="miro app" />
        <img src="assets/pro-create.png" title="Procreate" alt="procreate app" />
        <img src="assets/premiere.png" title="Premiere" alt="premiere app" />
      </ScrollContainer>
    </Container>
  );
};

export default Tools;
